import React from 'react';
import Header from './Header';
import Hero from './Hero';
import VideoSection from './VideoSection';
import TrustConfirmation from './TrustConfirmation';
import ExcursionsSection from './ExcursionsSection';
import PackagesSection from './PackagesSection';
import HowItWorks from './HowItWorks';
import TestimonialsSection from './TestimonialsSection';
import FAQSection from './FAQSection';
import FinalCTA from './FinalCTA';
import Footer from './Footer';
import StickyWhatsAppMobile from './StickyWhatsAppMobile';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <VideoSection />
        <TrustConfirmation />
        <ExcursionsSection />
        <PackagesSection />
        <HowItWorks />
        <TestimonialsSection />
        <FAQSection />
        <FinalCTA />
      </main>
      <Footer />
      <StickyWhatsAppMobile />
    </div>
  );
};

export default LandingPage;
